module.exports = __webpack_public_path__ + "static/media/logo_forcontrol.fecfd1c5.png";